<div class="add-custom-track">
    <div class="row-group">
        <div class="dialog-header">
            <div class="add-your-annotation">Edit custom tracks</div>
            <img class="row-child" alt="" src="assets/img/toastclose.svg" width="16" (click)="onClose()" />
        </div>
        <div class="dialog-body">
            
            @for(item of customTracks; track item.id; let i = $index){
            
            <div class="tracks-list">
                <div class="text-field">
                    <input class="vf-form__input input-text" type="text" name="trackName_{{item.id}}" value="{{item.name}}" [ngClass]="{ 'input-error': trackNameErrors[i] !== undefined }" [(ngModel)]="trackNames[i]" (input)="onTrackNameInput(i)" placeholder="Track 1" />
                    <p *ngIf="trackNameErrors[i] !== undefined" class="error-message">{{ trackNameErrors[i] }}</p>
                </div>
                <div class="text-field">
                    <input class="vf-form__input input-text" type="text" name="residueRanges_{{item.id}}" value="{{item.rawData.residueRanges}}" [ngClass]="{ 'input-error': residueRangesErrors[i].length > 0 }" [(ngModel)]="residueRanges[i]" (input)="onResidueRangesInput(i)" [placeholder]="item.rawData.residueRanges" />
                    <p *ngIf="residueRangesErrors[i].length > 0" class="error-message">{{ residueRangesErrors[i][0] }}</p>
                </div>

                <a class="delete-link" (click)="deleteTrack(item.id)"> <span class="delete">Delete</span><img class="row-child" alt="" src="assets/img/delete-track.svg" width="16"  /></a>
        
            </div>
            }
           
            <div class="we-do-not">We do not store this data. This data is kept only in the browser and will be deleted when you close the tab. </div>
        </div>
        <div class="dialog-footer">
            <div class="button-wrapper" id="frameContainer">
                <a class="delete cancle-link" (click)="onClose()">Cancel changes</a>
                <a class="button-primary vf-button vf-button--primary vf-button--sm" (click)="editTrack()">Save changes</a>
            </div>
        </div>
    </div>
</div>
  	
  	